exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-action[data-v-137c9a60] {\n  display: flex;\n  align-items: center;\n  padding: 0 0.25rem;\n}", ""]);

// exports
